import React from 'react'

interface BodyProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'className'> {
  children: React.ReactNode
}

export function Body ({ children, ...props }: BodyProps) {
  return (
    <div
      {...props}
      className='grow p-6 space-y-3 xs:space-y-4 overflow-y-auto outline -outline-offset-2 outline-2 outline-transparent focus-visible:outline-thatch-500'
    >
      {children}
    </div>
  )
}

Body.displayName = 'Modal.Body'
